import {assert, getOperationName} from "@prosay/common"
import {getLogger} from "@prosay/logging"
import validation from "@prosay/validation"
import {DocumentNode} from "graphql"
import * as yup from "yup"

const logger = getLogger(__filename)

export const getValidationSchema = logger.debug(
    <T = unknown>(document: DocumentNode) => {
        /*
        Get the validation schema with the operation type and name of `document` if it exists.
        Otherwise, throw an error.
    */
        const [operationType, name] = getOperationName(document)
        assert(
            validation[operationType],
            `Operation ${operationType} not found!`,
        )
        const operation = (validation[operationType] as unknown) as {
            [key: string]: yup.Schema<T> | undefined
        }

        const schema = operation[name]
        assert(schema, `Operation ${operationType}.${name} not found!`)
        return [schema, `${operationType}.${name}`] as const
    },
    "getValidationSchema",
)

const OPTIMISTIC_PREFIX = "OPTIMISTIC_"
export const getOptimisticId = (id: string) => `${OPTIMISTIC_PREFIX}${id}`
export const isOptimisticId = (id: string) => id.startsWith(OPTIMISTIC_PREFIX)
